import React from 'react';
import { useDispatch } from 'react-redux';

import TableWithSummary from '../../../../../components/table/TableWithSummary';
import {
  ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_SORT_OPTION_MODEL,
} from './models';
import { FOLLOW_TAG_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/accountUserConstants';
import { appActions } from '../../../../../store/modules/app';
import columns from './columns';
import { useAccountUserDetailTagList } from './hooks';

const AccountUserDetailTagInfo = (props) => {
  const { userId, isActive } = props;
  const dispatch = useDispatch();
  const { tagHistory, getList, sortOption, filterOption } = useAccountUserDetailTagList({ userId, isActive });
  const { list, totalCnt } = tagHistory;

  const getRelatedTagList = (payload) => dispatch(appActions.getRelatedTagList(payload));

  return (
    <div className="account-user-detail-content">
      <div className="account-user-detail-section">
        <div className="title">팔로우 태그 리스트</div>

        <div className="account-user-detail-section-content">
          <TableWithSummary
            className="account-user-detail-section-list"
            data={list}
            totalCnt={totalCnt}
            isStriped={true}
            emptyText={FOLLOW_TAG_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_FILTER_OPTION_MODEL,
              sortOption: ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_SORT_OPTION_MODEL,
            }}
            filterOption={filterOption}
            sortOption={sortOption}
            getList={getList}
            columns={(utils) =>
              columns({
                ...utils,
                getRelatedTagList,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AccountUserDetailTagInfo;
